import { useQuery } from "@tanstack/react-query";
import adminApiClient from "api/admin";

export const STUDIO_CONTRACT_QUERY_KEY = "studio-contract";

const useStudioContract = () => {
  return useQuery({
    queryKey: [STUDIO_CONTRACT_QUERY_KEY],
    queryFn: () => adminApiClient.getStudioContract(),
  });
};

export default useStudioContract;
